module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-9-600e6644131f9e1c904c4b596d8c15d0.svg";